<div class="container" tabindex="0" #focusBegin>
    <button
      [ngClass]="['burger-button', size, isOpen ? 'open' : '', 'className']"
      (click)="onClick()"
      [attr.aria-label]="ariaLabel"
      [attr.aria-expanded]="isOpen"
      type="button"
    >
      <span class="line" [ngStyle]="{'background-color': color}"></span>
      <span class="line" [ngStyle]="{'background-color': color}"></span>
      <span class="line" [ngStyle]="{'background-color': color}"></span>
    </button>
  </div>
